import { Stack } from '@mui/material'
import { preview } from '@/components/form/preview'

import { InfoOutlined } from '@mui/icons-material'

import { Tooltip } from '@/components/primitives/Tooltip'

import { useTexts } from '../hooks/useTexts'

interface Props {
  driver: uui.domain.client.rm.ExtendedDriver
  trackingProvider: uui.domain.server.gps.TrackingProvider
}

export function DriverApp(props: Props) {
  const { trackingProvider, driver } = props

  const { titles, labels, values } = useTexts()

  const tracked = driver.type === 'linked'

  return (
    <>
      <preview.SectionTitle>{titles.driverApp}</preview.SectionTitle>

      {trackingProvider !== 'telematics' && (
        <preview.Field label={labels.driverTracked} color={tracked ? undefined : 'textSecondary'}>
          <Stack gap={1} component="span" direction="row">
            {labels.tracked(tracked)}
            {tracked && (
              <Tooltip
                placement="bottom"
                title={driver.type === 'linked' ? driver.device.label : ''}
              >
                <InfoOutlined />
              </Tooltip>
            )}
          </Stack>
        </preview.Field>
      )}

      <preview.Section>
        {trackingProvider !== 'telematics' && (
          <preview.SectionSubtitle>{titles.routeViewPreferences}</preview.SectionSubtitle>
        )}
        <preview.Field label={labels.mobileFutureDaysVisibility}>
          {values.mobileFutureDaysVisibility(driver.driver.mobileFutureDaysVisibility)}
        </preview.Field>
      </preview.Section>

      <preview.Field label={labels.summarizeFutureMobileRoute}>
        {values.summarizeFutureMobileRoute(driver.driver.summarizeFutureMobileRoute)}
      </preview.Field>
    </>
  )
}
